module.exports = __webpack_public_path__ + "static/media/mob-paintathon-dppage.e227522d.png";